import image1 from '@/assets/images/news/detail/2021051801/1.jpg';
import image2 from '@/assets/images/news/detail/2021051801/2.jpg';
import image3 from '@/assets/images/news/detail/2021051801/3.jpg';

export default {
  id: '2021051801', //  模块 id
  title: '在上海崇明和江苏盐城承包3万亩土地，叮咚买菜启动大米订单种植项目', // 标题
  origin: '2021-05-18 19:51 来源：上海观察', // 新闻来源
  editor: '编辑：王志彦', // 编辑者
  content: [
    {
      type: 0,
      text:
        '今年是叮咚买菜发力大米订单农业的第一年，预计全年大米销售量将达6万吨。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '午后，在崇明新村乡的叮咚买菜大米订单种植基地里，几台插秧机正在忙碌地进行自动化插秧作业，这些早稻大米将于今年10月丰收，通过叮咚买菜的智慧供应链和终端配送，成为全国各大城市千家万户的“盘中餐”。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '日前，叮咚买菜与上海崇明新村乡人民政府签署战略合作协议，启动了叮咚买菜2021年度早稻大米订单农业项目。而在同为大米优质产区的江苏盐城，叮咚买菜建设的中晚稻大米订单农业基地也同步启动，整体“承包”面积达3万亩。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '一碗兼具营养和口感的米饭，是中国人日常餐桌上不可或缺的“重头戏”。为了让大家吃上好吃又放心的好米饭，叮咚买菜从种子就开始下足功夫。在种植端，叮咚买菜综合市场消费大数据和专家团队的测评研究，在众多品种中优选了一年一季“种子选手”，作为大米订单种植基地的指定品种。从插秧到收获，采购专家和品控团队将全程驻扎基地，严控大米品质。此外，在大米的加工到终端配送环节，叮咚买菜也分别设立叮咚专属标准，实现大米产品的全程可追溯。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜高级副总裁徐志坚表示，走向产地、以科技创新推动农业供给侧升级，是叮咚买菜一直以来坚持的发展方向。今年是叮咚买菜发力大米订单农业的第一年，预计全年大米销售量将达6万吨。叮咚买菜将充分发挥自身的渠道、数据、供应链优势，与上游大米种植产地的资源有效打通与整合，合力助推国内大米产业的品牌化、数字化升级。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '大米订单种植基地只是叮咚买菜产地战略的一个缩影。除了在全球20多个地区建设350个生鲜直采基地外，越来越多的“叮咚农场”在全国各个优质生鲜产地陆续启动。2020年9月，叮咚买菜智慧农业示范园在上海金山区廊下镇落户，首批蔬菜叮咚人自己种的蔬菜已于2021年2月上架售卖；2021年4月，叮咚买菜首个订单化大闸蟹养殖基地在江苏宝应启动，今年秋天叮咚养的大闸蟹也将出现在用户的餐桌……这些带有叮咚标签的优质生鲜产地，也将为叮咚买菜正在建立的集标准生产、农产品加工、冷链配送、线上售卖为一体的智慧农业全产业链体系，打下基础。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '徐志坚表示，叮咚买菜未来还将持续在全国范围拓展产地布局，预计明年大米订单农业基地面积将达5万亩。',
      isIndent: false,
    },
  ],
};
